import moment from 'moment';
import _ from 'lodash';

const weekOfMonth = batchDate => {
  let date = batchDate;
  let monthDate = date.date();
  if (monthDate < 4) {
    date = date.subtract('1', 'M').endOf('month');
  }
  let weekChange = 0;
  const startOf = date.clone();
  if (startOf.startOf('month').weekday() !== 0 && startOf.startOf('month').weekday() < 5) weekChange = 1;
  const weekDate = date.weekday();
  monthDate = date.date();
  let week = _.floor(monthDate / 7) + weekChange;
  if (weekDate !== 0 && weekDate < monthDate % 7) week += 1;
  return `${date.format('MMM')} Week${week}`;
};
export default {
  getLastBatchDate: ({ weekChanges }) => {
    if (weekChanges.length > 0) {
      return moment(weekChanges[weekChanges.length - 1].batchDate)
        .utc(true)
        .format('YYYY-MM-DD');
    }
  },
  getWeekChangeData: ({ weekChanges }) => {
    const returnArr = [];
    for (let index = 0; index < 8 - weekChanges.length; index += 1) {
      returnArr.push(0);
    }
    weekChanges.forEach(obj => returnArr.push(obj.keyCnt));
    return returnArr;
  },
  getWeekChangeAxis: ({ weekChanges }) => {
    const returnArr = [];
    for (let index = 0; index < 8 - weekChanges.length; index += 1) {
      returnArr.push('');
    }
    weekChanges.forEach(obj => {
      const date = moment(obj.batchDate).utc(true);
      returnArr.push(weekOfMonth(date));
    });
    return returnArr;
  },
  getNewCreateKey: ({ lastSummary }) => {
    const returnArr = [];
    const newKeyDivSet = new Set();
    lastSummary.forEach(obj => {
      newKeyDivSet.add(obj.divisionCode);
    });
    newKeyDivSet.forEach(div => {
      const returnObj = { name: div };
      let sumDivKey = 0;
      _.filter(lastSummary, obj => obj.divisionCode === div).forEach(obj => {
        sumDivKey += obj.newkeyCnt;
      });
      returnObj.value = sumDivKey;
      returnArr.push(returnObj);
    });
    return returnArr;
  },
  getCurrentKey: ({ lastSummary }) => {
    const returnArr = [];
    const currentKeyDivSet = new Set();
    lastSummary.forEach(obj => {
      currentKeyDivSet.add(obj.divisionCode);
    });
    currentKeyDivSet.forEach(div => {
      const returnObj = { name: div };
      let sumDivKey = 0;
      _.filter(lastSummary, obj => obj.divisionCode === div).forEach(obj => {
        sumDivKey += obj.keyCnt;
      });
      returnObj.value = sumDivKey;
      returnArr.push(returnObj);
    });
    return returnArr;
  },
  getSummedLast: ({ lastSummary }) => {
    const result = {
      keyCnt: 0,
      elapsedkeyCnt90: 0,
      elapsedkeyCnt80: 0,
      elapsedkeyCnt70: 0,
      elapsedkeyCnt60: 0,
      newkeyCnt: 0,
      deletedKeyCnt: 0,
      exceptKeyCnt: 0,
      lesskeyCnt60: 0,
      newkeyTodayCnt: 0,
      cspExceptKeyCnt: 0,
      thirdExceptKeyCnt: 0,
      etcExceptKeyCnt: 0,
    };
    lastSummary.forEach(obj => {
      Object.entries(obj).map(([key, value]) => {
        result[key] += value;
      });
    });
    return result;
  },
  getExceptKeys({ exceptKeys }) {
    return exceptKeys;
  },
  getD1Cnt({ d1Cnt }) {
    return d1Cnt;
  },
};



// WEBPACK FOOTER //
// ./src/vuex/accKey/summary/accKeySummaryGetter.js